var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 840,
    height: 726.849,
    viewBox: "0 0 840 726.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.386,
    y1: 7.85,
    x2: -1.386,
    y2: 6.809,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_Taken_if77",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 146.46,
    cy: 113.46,
    rx: 146.46,
    ry: 113.46,
    transform: "translate(285.54 18.85)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    d: "M143.21,0C222.3,0,286.42,49.67,286.42,110.94S222.3,221.88,143.21,221.88,0,172.21,0,110.94,64.117,0,143.21,0Z",
    transform: "translate(288.79 21.37)",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M491.94,231.21c0-61.27,64.11-110.94,143.2-110.94A175.54,175.54,0,0,1,706.5,135c-25.17-17-58.1-27.33-94.14-27.33-79.09,0-143.21,49.67-143.21,110.94,0,41.14,28.91,77.05,71.86,96.21C510.94,294.48,491.94,264.57,491.94,231.21Z",
    transform: "translate(-180 -86.57)",
    fill: "#334155",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M432,176.9,590.76,451.88,749.52,726.85H114.48L273.24,451.88Z",
    fill: "#f1f5f9",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M649.67,652.79,662,616.2a62.66,62.66,0,0,0-23.2-70.89l.1-.06a61.48,61.48,0,0,0-15.79-8h0l-.17-.06-.19-.06h0a61.55,61.55,0,0,0-16.9-3.18,59.272,59.272,0,0,0-6.11,0,62.316,62.316,0,0,0-10.49,1.45c-1,.22-2,.47-2.91.74s-1.93.56-2.88.87c-1.9.63-3.77,1.34-5.6,2.15-.92.4-1.83.82-2.72,1.27a61.46,61.46,0,0,0-7.75,4.56c-.83.57-1.64,1.16-2.44,1.76a62,62,0,0,0-21.24,29.6L524.33,634a61.861,61.861,0,0,0-2.68,28.12c.2,1.45.45,2.89.74,4.32s.65,2.84,1,4.24c.27.93.55,1.86.86,2.78.46,1.37,1,2.74,1.51,4.08.37.89.76,1.78,1.17,2.66.81,1.75,1.71,3.46,2.68,5.13a54.1,54.1,0,0,0,3.16,4.88c.84,1.18,1.73,2.34,2.65,3.46a52.246,52.246,0,0,0,3.92,4.33,61.809,61.809,0,0,0,21,13.89h0l.34.14a21.647,21.647,0,0,1,1.4-2.17c3-4.11,8.22-7,13.19-5.92.36.08.72.19,1.08.3,2.52.89,5,2.48,7.43,3.26a6.66,6.66,0,0,0,5.61-.07c4.86-2.59,3.06-10.76,7.23-14.34a6.5,6.5,0,0,1,.61-.46,1.9,1.9,0,0,1-.16-.23c3.22-2,7.68-.67,11.39.62,4,1.41,9.22,2.36,12-.91,1.88-2.24,1.74-5.65,3.53-8,2.08-2.7,6-3,9.39-2.52l.17.05c6.5,2.68,13.6-1.77,13.1-8.78a54.765,54.765,0,0,1,3.02-20.07Z",
    transform: "translate(-180 -86.57)",
    fill: "#f1f5f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M563.21,706.78c2.92-4,7.93-6.8,12.73-5.71s9.35,5.66,13.62,3.37c5.84-3.12,1.7-14.59,11.18-15.44a12.441,12.441,0,0,1,5.77,1c4,1.63,10.26,3.47,13.34-.2,1.81-2.16,1.68-5.45,3.41-7.69,2-2.6,5.81-2.93,9.06-2.43l.16.05c6.27,2.59,13.13-1.71,12.64-8.47-.63-9,2.23-17.48,2.85-19.32l11.88-35.31A60.38,60.38,0,0,0,622,540.34h0a60.38,60.38,0,0,0-76.27,37.86L527,633.73a60.39,60.39,0,0,0,34.82,75.15,21.445,21.445,0,0,1,1.39-2.1Z",
    transform: "translate(-180 -86.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 6.51,
    cy: 6.51,
    r: 6.51,
    transform: "translate(398.84 479.57)",
    fill: "#475569",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 6.51,
    cy: 6.51,
    r: 6.51,
    transform: "translate(435.86 492.02)",
    fill: "#475569",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 9.76,
    cy: 6.51,
    rx: 9.76,
    ry: 6.51,
    transform: "matrix(0.319, -0.948, 0.948, 0.319, 406.3, 524.221)",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 9.76,
    cy: 9.76,
    r: 9.76,
    transform: "translate(542.77 477.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 4.88,
    cy: 4.88,
    r: 4.88,
    transform: "translate(578.57 467.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(423 44.43)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(358 74.43)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(483 87.43)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M662.67,259.79,675,223.2a62.66,62.66,0,0,0-23.2-70.89l.1-.06a61.477,61.477,0,0,0-15.79-8h0l-.17-.06-.19-.06h0a61.55,61.55,0,0,0-16.9-3.18,59.264,59.264,0,0,0-6.11,0,62.32,62.32,0,0,0-10.49,1.45c-1,.22-2,.47-2.91.74s-1.93.56-2.88.87c-1.9.63-3.77,1.34-5.6,2.15-.92.4-1.83.82-2.72,1.27a61.467,61.467,0,0,0-7.75,4.56c-.83.57-1.64,1.16-2.44,1.76a62,62,0,0,0-21.24,29.6L537.33,241a61.858,61.858,0,0,0-2.68,28.12c.2,1.45.45,2.89.74,4.32s.65,2.84,1,4.24c.27.93.55,1.86.86,2.78.46,1.37,1,2.74,1.51,4.08.37.89.76,1.78,1.17,2.66.81,1.75,1.71,3.46,2.68,5.13a54.078,54.078,0,0,0,3.16,4.88c.84,1.18,1.73,2.34,2.65,3.46,1.24,1.5,2.54,2.95,3.92,4.33a61.81,61.81,0,0,0,21,13.89h0l.34.14a21.648,21.648,0,0,1,1.4-2.17c3-4.11,8.22-7,13.19-5.92.36.08.72.19,1.08.3,2.52.89,5,2.48,7.43,3.26a6.66,6.66,0,0,0,5.61-.07c4.86-2.59,3.06-10.76,7.23-14.34a6.509,6.509,0,0,1,.61-.46,1.887,1.887,0,0,1-.16-.23c3.22-2,7.68-.67,11.39.62,4,1.41,9.22,2.36,12-.91,1.88-2.24,1.74-5.65,3.53-8,2.08-2.7,6-3,9.39-2.52h.17c6.5,2.68,13.6-1.77,13.1-8.78C659.06,270.51,662,261.7,662.67,259.79Z",
    transform: "translate(-180 -86.57)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M576.21,313.78c2.92-4,7.93-6.8,12.73-5.71s9.35,5.66,13.62,3.37c5.84-3.12,1.7-14.59,11.18-15.44a12.44,12.44,0,0,1,5.77,1c4,1.63,10.26,3.47,13.34-.2,1.81-2.16,1.68-5.45,3.41-7.69,2-2.6,5.81-2.93,9.06-2.43l.16.05c6.27,2.59,13.13-1.71,12.64-8.47-.63-9,2.23-17.48,2.85-19.32l11.88-35.31A60.38,60.38,0,0,0,635,147.34h0a60.38,60.38,0,0,0-76.27,37.86L540,240.73a60.39,60.39,0,0,0,34.82,75.15,21.447,21.447,0,0,1,1.39-2.1Z",
    transform: "translate(-180 -86.57)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 6.51,
    cy: 6.51,
    r: 6.51,
    transform: "translate(411.84 86.57)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 6.51,
    cy: 6.51,
    r: 6.51,
    transform: "translate(448.86 99.02)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M749.52,186a87.515,87.515,0,0,1,2.79,22c0,61.27-64.11,110.94-143.2,110.94C544.38,318.9,489.69,285.64,472,240c13.14,50.77,71,89,140.41,89,79.09,0,143.21-49.67,143.21-110.94a88.159,88.159,0,0,0-6.1-32.06Z",
    transform: "translate(-180 -86.57)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 296.18,
    cy: 77.41,
    rx: 296.18,
    ry: 77.41,
    transform: "translate(135.82 103.27)",
    fill: "#cbd5e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M612,192.4c-158.18,0-286.42,33.51-286.42,74.86H898.42C898.42,225.91,770.18,192.4,612,192.4Z",
    transform: "translate(-180 -86.57)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M612,342.11c158.18,0,286.42-33.51,286.42-74.85H325.58C325.58,308.6,453.82,342.11,612,342.11Z",
    transform: "translate(-180 -86.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M612,342.11c158.18,0,286.42-33.51,286.42-74.85H325.58C325.58,308.6,453.82,342.11,612,342.11Z",
    transform: "translate(-180 -86.57)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 273.4,
    height: 39.06,
    rx: 17.22,
    transform: "translate(295.3 161.15)",
    fill: "#475569",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M313.89,144.38a3.68,3.68,0,0,1-2.05-4.44,1.86,1.86,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.82,1.82,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2.05,2,2,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.619,1.619,0,0,0,.36.21,3.68,3.68,0,0,1,2.05,4.44,1.889,1.889,0,0,0-.08.4h0a1.84,1.84,0,0,0,3.31,1.23h0a1.649,1.649,0,0,0,.2-.37,3.67,3.67,0,0,1,4.44-2,2,2,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.621,1.621,0,0,0,313.89,144.38Z",
    transform: "translate(-180 -86.57)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M822.89,450.38a3.68,3.68,0,0,1-2-4.44,1.851,1.851,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.817,1.817,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2.05,2,2,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.622,1.622,0,0,0,.36.21,3.68,3.68,0,0,1,2,4.44,1.89,1.89,0,0,0-.08.4h0a1.84,1.84,0,0,0,3.31,1.23h0a1.645,1.645,0,0,0,.2-.37,3.67,3.67,0,0,1,4.44-2,2,2,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0a1.62,1.62,0,0,0-.36-.25Z",
    transform: "translate(-180 -86.57)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M260.89,592.38a3.68,3.68,0,0,1-2.05-4.44,1.859,1.859,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.817,1.817,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2.05,2,2,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.619,1.619,0,0,0,.36.21,3.68,3.68,0,0,1,2.05,4.44,1.891,1.891,0,0,0-.08.4h0a1.84,1.84,0,0,0,3.31,1.23h0a1.647,1.647,0,0,0,.2-.37,3.67,3.67,0,0,1,4.44-2,2,2,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0a1.62,1.62,0,0,0-.36-.25Z",
    transform: "translate(-180 -86.57)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M205.89,261.38a3.68,3.68,0,0,1-2-4.44,1.859,1.859,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.82,1.82,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2.05,2,2,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.621,1.621,0,0,0,.36.21,3.68,3.68,0,0,1,2.05,4.44,1.889,1.889,0,0,0-.08.4h0a1.84,1.84,0,0,0,3.31,1.23h0a1.65,1.65,0,0,0,.2-.37,3.67,3.67,0,0,1,4.44-2,2,2,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.62,1.62,0,0,0,205.89,261.38Z",
    transform: "translate(-180 -86.57)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M812.89,93.38a3.68,3.68,0,0,1-2-4.44,1.858,1.858,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.818,1.818,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2,2,2,0,0,0-.41-.08h0A1.84,1.84,0,0,0,801.34,93h0a1.618,1.618,0,0,0,.36.21,3.68,3.68,0,0,1,2,4.44,1.885,1.885,0,0,0-.08.4h0A1.84,1.84,0,0,0,807,99.23h0a1.65,1.65,0,0,0,.2-.37,3.67,3.67,0,0,1,4.44-2,2,2,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0a1.623,1.623,0,0,0-.38-.25Z",
    transform: "translate(-180 -86.57)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 3,
    height: 17,
    transform: "translate(110 257.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 3,
    height: 17,
    transform: "translate(120 264.85) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 3,
    height: 17,
    transform: "translate(830 177.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 3,
    height: 17,
    transform: "translate(840 184.85) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 3,
    height: 17,
    transform: "translate(730 456.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 3,
    height: 17,
    transform: "translate(740 463.85) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(717 75.85)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(0 6.85)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(180 351.85)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(200 147.43)",
    fill: "#475569",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(200 200.43)",
    fill: "#475569",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(587 147.43)",
    fill: "#475569",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(587 200.43)",
    fill: "#475569",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(398 117.43)",
    fill: "#475569",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 34,
    cy: 7,
    rx: 34,
    ry: 7,
    transform: "translate(398 221.43)",
    fill: "#475569",
    opacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.f7937bee3020ad8868e9d4887700573d.svg";
export { ForwardRef as ReactComponent };